import { render, staticRenderFns } from "./MockNotificationBtn.vue?vue&type=template&id=3fe4b910"
import script from "./MockNotificationBtn.vue?vue&type=script&lang=js"
export * from "./MockNotificationBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports